'use strict';

// возвращает если не null
export function isnull(val)
{   
    if(val === undefined || val == null || val == "") return true;
    return false;
}
export function isId(val)
{   
    if(val === undefined || val == null || val == "" || val < 0) return false;
    return true;
}

export default isnull;